"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePanel = void 0;
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const AuditDisplay_1 = __importDefault(require("../AuditDisplay"));
const SurveyObjectBox_1 = require("./SurveyObjectBox");
const LastActionWidget_1 = require("./LastActionWidget");
const HomePanel = ({ home, audits, showAuditErrorCode, inheritedStatus }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { t } = (0, react_i18next_1.useTranslation)(['admin']);
    if (!home) {
        return (react_1.default.createElement("div", { className: "admin__interview-stats", key: "home" },
            react_1.default.createElement("details", { open: true, className: "admin__survey-object-box" },
                react_1.default.createElement("summary", null,
                    react_1.default.createElement("h4", { style: { display: 'inline', margin: 0 } }, t('Home'))),
                react_1.default.createElement("span", { className: "_widget _red" }, t('survey:homeNotAvailable')),
                audits && audits.length > 0 && (react_1.default.createElement(AuditDisplay_1.default, { audits: audits, showAuditErrorCode: showAuditErrorCode })))));
    }
    const homeAddress = ((_a = home.address) === null || _a === void 0 ? void 0 : _a.fullAddress) ||
        `${((_b = home.address) === null || _b === void 0 ? void 0 : _b.municipalityName) || ''} ${((_c = home.address) === null || _c === void 0 ? void 0 : _c.region) || ''} ${((_d = home.address) === null || _d === void 0 ? void 0 : _d.country) || ''} ${((_e = home.address) === null || _e === void 0 ? void 0 : _e.postalCode) || ''}`.trim() ||
        '';
    const lastAction = (_g = (_f = home.geography) === null || _f === void 0 ? void 0 : _f.properties) === null || _g === void 0 ? void 0 : _g.lastAction;
    return (react_1.default.createElement("div", { className: "admin__interview-stats", key: "home" },
        react_1.default.createElement(SurveyObjectBox_1.SurveyObjectBox, { as: "details", defaultOpen: true, objectType: "home", objectUuid: home._uuid, inheritedStatus: inheritedStatus, summary: react_1.default.createElement("summary", null,
                react_1.default.createElement("h4", { style: { display: 'inline', margin: 0 } }, t('Home'))) },
            react_1.default.createElement("span", { className: "_widget" },
                react_1.default.createElement("span", { className: "_strong" },
                    homeAddress,
                    ' ',
                    ((_h = home.address) === null || _h === void 0 ? void 0 : _h.unitNumber)
                        ? t('interviewStats.labels.unnitNumber') + ((_j = home.address) === null || _j === void 0 ? void 0 : _j.unitNumber)
                        : '',
                    ' ',
                    ((_k = home.address) === null || _k === void 0 ? void 0 : _k.municipalityName) ? (_l = home.address) === null || _l === void 0 ? void 0 : _l.municipalityName : '')),
            react_1.default.createElement(LastActionWidget_1.LastActionWidget, { lastAction: lastAction }),
            audits && audits.length > 0 && (react_1.default.createElement(AuditDisplay_1.default, { audits: audits, showAuditErrorCode: showAuditErrorCode })))));
};
exports.HomePanel = HomePanel;
//# sourceMappingURL=HomePanel.js.map